/* global grecaptcha -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
if (document.getElementById('form-contact')) {
    window.onGoogleReCaptchaCallback = function () {
        //Show a message in the submit button, when the form is submitting.
        const submitButton = document.getElementById('contact-submit');
        submitButton.innerHTML = 'Please wait...';
        submitButton.classList.add('disabled');

        //Submit the form
        document.getElementById('form-contact').submit();
    };

    $(document).ready(function () {
        //Handle validation
        $('#form-contact').parsley();
        $('#form-contact').on('submit', function (e) {
            e.preventDefault();

            const isValid = $(this).parsley('isValid');

            if (isValid) {
                grecaptcha.execute();
            }
        });
    });
}
